import * as Yup from 'yup';

export const shippingAddressValidationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .max(30, 'First name must be at most 30 characters')
    .required('First name is required'),

  lastName: Yup.string()
    .trim()
    .max(30, 'Last name must be at most 30 characters')
    .required('Last name is required'),

  streetAddress: Yup.string()
    .trim()
    .max(100, 'Street address must be at most 100 characters')
    .required('Street address is required'),

  country: Yup.string()
    .trim()
    .max(30, 'Country must be at most 30 characters')
    .required('Country is required'),

  stateProvince: Yup.string()
    .trim()
    .max(30, 'State must be at most 30 characters')
    .required('State is required'),

  suburbCity: Yup.string()
    .trim()
    .max(30, 'City must be at most 30 characters')
    .required('City is required'),

  postalCode: Yup.string()
    .trim()
    .min(1, 'Postal code must be at least 1 characters')
    .max(4, 'Postal code must be at most 4 characters')
    .matches(/^\d+$/, 'Only numbers are allowed')
    .required('Postal code is required'),

  mobilePhone: Yup.string()
    .trim()
    .matches(/^\d+$/, 'Only numbers are allowed')
    .max(15, 'Mobile phone number must be at most 15 digits')
    .required('Mobile phone number is required'),

  addressSearch: Yup.string()
    .trim()
    .max(200, 'Address search must be at most 200 characters'),
});
